import type { OrgGroup } from './Types';
import camelcaseKeys from 'camelcase-keys';

import { AdvancedAnalyticsStatus, type Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class AdvancedAnalyticsRequester {
  private requester: Requester;

  private readonly baseUrl: string;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
    this.baseUrl = '/advanced-analytics/v1';
  }

  public requestDwCreation = async (): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/dw/request`,
      method: HttpMethod.POST,
    };

    await this.requester.request(requestData);
  };

  public getDwStatus = async (): Promise<AdvancedAnalyticsStatus> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/dw/status`,
      method: HttpMethod.GET,
    };

    return this.requester.request(requestData).then((response) => {
      const statusString = response.data as keyof typeof AdvancedAnalyticsStatus;
      return AdvancedAnalyticsStatus[statusString];
    });
  };

  public getDwOrgGroup = async (): Promise<OrgGroup> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/dw`,
      method: HttpMethod.GET,
    };
    const { data } = await this.requester.request(requestData);
    return camelcaseKeys(data, { deep: true });
  };

  public getUserDashboard = async (): Promise<string | undefined> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/dashboard`,
      method: HttpMethod.GET,
    };
    const { data } = await this.requester.request(requestData);
    return data?.dashboard_link;
  };

  public saveUserDashboard = async (dashboardLink: string): Promise<string> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/dashboard`,
      method: HttpMethod.POST,
      body: JSON.stringify({
        dashboard_link: dashboardLink,
      }),
    };
    const { data } = await this.requester.request(requestData);
    return data.dashboard_link;
  };
}

export default AdvancedAnalyticsRequester;
